import React, { useState } from 'react';
import { TextField, Button, Box, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ModalWithTextField = ({ open, onClose, addNewKey }) => {
  const [textFieldValue, setTextFieldValue] = useState('');

  const handleInputChange = (event) => {
    setTextFieldValue(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.which === 13 && textFieldValue.trim()) {
      addNewKey(textFieldValue);
      setTextFieldValue('');
      onClose();
    }
  };

  const handleSave = () => {
    if (textFieldValue.trim()) {
      addNewKey(textFieldValue);
      setTextFieldValue('');
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          className: 'dark:text-cool-gray',
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      }}
    >
      <Box
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px',
          width: '100%',
          maxWidth: '400px',
          position: 'relative',
          className: 'font-figtree h-full w-full relative',
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: '8px',
            top: '8px',
            className: 'dark:text-quicksilver group-hover:text-quicksilver',
          }}
        >
          <CloseIcon />
        </IconButton>
        <div className="w-full flex justify-center">
          <div className="text-raisin-black dark:text-crystal-bell text-[20px] leading-7 font-bold text-center">
            Name your new key
          </div>
        </div>
        <TextField
          label="Key name"
          value={textFieldValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          fullWidth
          variant="outlined"
          sx={{
            marginBottom: '16px',
            borderRadius: '8px',
            '&.MuiInputBase-root': {
              fontSize: '16px',
              className: 'dark:text-seasalt',
            },
            '&.MuiOutlinedInput-notchedOutline': {
              borderColor: 'dark: #757575',
            },
            '&.MuiInputLabel-root': {
              className: 'dark:text-seasalt',
            },
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          sx={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            borderRadius: '8px',
            textTransform: 'none',
            transition: 'background-color 0.3s',
            className: 'bg-nue-blue hover:bg-nue-blue/70 text-white',
          }}
        >
          Save
        </Button>
      </Box>
    </Dialog>
  );
};

export default ModalWithTextField;
